import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { autorun } from 'mobx';
import { Badge } from '@material-ui/core';
import { guarantorsStore, propertiesStore, anketsStore } from 'stores';
import { ru } from 'locale';
import useStyles from './GuarantorsPropertiesText.styles';

const GuarantorsPropertiesText = observer(() => {
  const classes = useStyles();
  const { fetchState: guarantorsState, guarantors } = guarantorsStore;
  const { fetchState: propertiesState, properties } = propertiesStore;
  const countGuarantors = guarantors.length;
  const countProperties = properties.length;

  useEffect(
    () =>
      autorun(() => {
        guarantorsStore.getGuarantors(anketsStore.anketId);
      }),
    [],
  );

  useEffect(
    () =>
      autorun(() => {
        propertiesStore.getProperties(anketsStore.anketId);
      }),
    [],
  );

  if (guarantorsState === 'fulfilled' && propertiesState === 'fulfilled')
    return (
      <>
        {ru.assuranceAndGuarantor}
        <Badge
          className={classes.badge}
          badgeContent={`${countProperties}/${countGuarantors}`}
          color="primary"
        >
          <span> </span>
        </Badge>
      </>
    );

  return <>{ru.assuranceAndGuarantor}</>;
});

export default GuarantorsPropertiesText;
